module.exports = __webpack_public_path__ + "img/375.c6578484.jpg";